import Cookies from 'js-cookie';
import { callAPI } from '..';
import { apiPath } from '..';
import { getCookieToken } from '..';

//取得完整的用戶資料，包含車輛與付款資訊
const getMemberProfile = async () => {
    try {
        const token = await getCookieToken();
        let headers = { 'token': token };

        const url = apiPath.GET_URL_MEMBERPROFILE;
        const method = 'GET';
        const response = await callAPI({ method, url, headers });
        const httpCode = response.status || -1;

        if (httpCode === 200) {
            let payload = null;

            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload);

            if (payload) {
                return payload;
            } else {
                return null;
            }
        } else if (httpCode !== -1) {
            alert(`網站遇到錯誤 - HTTP 狀態碼: httpCode`);
            return null;
        } else {
            console.error('API 未執行:', url);
            return null;
        }
    } catch (error) {
        console.error('Error :', error);
        return null;
    }
};

//用戶目前停車狀況查詢
const getCurrentStatus = async () => {
    try {
        const token = await getCookieToken();
        let headers = { 'token': token };

        const url = apiPath.GET_URL_CURRENTSTATUS;
        const method = 'GET';
        const response = await callAPI({ method, url, headers });
        const httpCode = response.status || -1;

        if (httpCode === 200) {
            let payload = null;

            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload);

            if (payload) {
                return payload;
            } else {
                return null;
            }
        } else if (httpCode !== -1) {
            alert(`網站遇到錯誤 - HTTP 狀態碼: httpCode`);
            return null;
        } else {
            console.error('API 未執行:', url);
            return null;
        }
    } catch (error) {
        console.error('Error :', error);
        return null;
    }
};

//用戶付款紀錄
const getHistory = async () => {
    try {
        const token = await getCookieToken();
        let headers = { 'token': token };

        const url = apiPath.GET_URL_HISTORY;
        const method = 'GET';
        const response = await callAPI({ method, url, headers });
        const httpCode = response.status || -1;

        if (httpCode === 200) {
            let payload = null;

            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload);

            if (payload) {
                return payload;
            } else {
                return null;
            }
        } else if (httpCode !== -1) {
            alert(`網站遇到錯誤 - HTTP 狀態碼: httpCode`);
            return null;
        } else {
            console.error('API 未執行:', url);
            return null;
        }
    } catch (error) {
        console.error('Error :', error);
        return null;
    }
};

export { getMemberProfile, getCurrentStatus, getHistory };